
<template>
  <div class="d-flex align-items-center">
    <el-image class="me-2" :src="fileTypeIcon(file.contentType)"
              style="max-width: 40px;object-fit: cover" />
    <div class="flex-1">
      <div class="fw-bolder"> {{ file.fileName }}</div>
      <LoadingBarFile :time-percent="time" />
    </div>

  </div>
</template>

<script>
import LoadingBarFile from "../common/LoadingBarFile";

export default {
  name: "FileLoading",
  components: { LoadingBarFile },
  props: ["file"],
  data() {
    return {
      time: 0
    };
  },
  created() {
    let MBperSecond=0.25
    let timeComplete = this.file.size / 1000 / MBperSecond;
    this.time = timeComplete / 100;
  }
};
</script>

<style scoped>

</style>